import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformRecommendedUsernames } from './recommended-usernames.transformers';
import type { RecommendedUsernamesCollection } from './recommended-usernames.types';

export function recommendedUsernamesReducer(
  state: CollectionStateSlice<RecommendedUsernamesCollection> = {},
  action: CollectionActions<RecommendedUsernamesCollection>,
): CollectionStateSlice<RecommendedUsernamesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'recommendedUsernames') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<RecommendedUsernamesCollection>(
          state,
          transformIntoDocuments(
            [result.recommended_name, ...result.alternate_names],
            transformRecommendedUsernames,
            {
              email: getQueryParamValue(ref.query, 'email')[0],
              baseName: getQueryParamValue(ref.query, 'baseName')[0],
            },
          ),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
